import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        navigationBar: () => import('@/layouts/SalePage/TheBar'),
        content: () => import('@/pages/Home'),
        footer: () => import('@/layouts/SalePage/TheFooter')
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        navigationBar: () => import('@/layouts/SalePage/TheBar'),
        content: () => import('@/pages/Login'),
        footer: () => import('@/layouts/SalePage/TheFooter')
      }
    },
    {
      path: '/require-permission',
      name: 'permission',
      components: {
        navigationBar: () => import('@/layouts/SalePage/TheBar'),
        content: () => import('@/pages/Permission'),
        footer: () => import('@/layouts/SalePage/TheFooter')
      }
    },
    {
      path: '/c/shop',
      name: 'c-shop',
      components: {
        navigationBar: () => import('@/layouts/Console/TheCShopBar'),
        content: () => import('@/pages/console/ConsoleShop'),
        footer: () => import('@/layouts/SalePage/TheFooter')
      },
      meta:
        {
          requiresAuth: true
        }
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let requireAuthentication = to.matched.some(record => record.meta.requiresAuth)
  if (requireAuthentication) {
    let user = store.state.user.status
    if (!user) {
      store.commit('user/setRouterTarget', to.name)
      next({
        name: 'login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
